import * as Schema from "./schema";
export { Schema };



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/schema/index.ts
// module id = lUuM
// module chunks = 2